import { View } from "./View";

export const SignIn = () => {
  return <View />;
};
